import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, map, timeout } from 'rxjs';

import { ConfigService } from '../services/config.service';
import { InfoscreenFeed, InfoscreenLegacyScreen } from './infoscreen-module.types';

/** Anonymous reads for the infoscreen module. The old screen keeps its own `InfoscreenService`. */
@Injectable({ providedIn: 'root' })
export class InfoscreenModuleService {
  private readonly http = inject(HttpClient);
  private readonly configService = inject(ConfigService);

  getFeed(screenId: number): Observable<InfoscreenFeed> {
    return this.http.get<InfoscreenFeed>(`${this.configService.getApiUrl()}/infoscreens/${screenId}/feed`);
  }

  /**
   * The configured screen that has taken over the old address for a location, or null. Bounded by
   * a timeout: the old screen waits for this on start-up and must not hang on a slow API.
   */
  getLegacyScreenId(locationId: number): Observable<number | null> {
    return this.http
      .get<InfoscreenLegacyScreen>(`${this.configService.getApiUrl()}/modules/infoscreen/legacy-screen`, {
        params: { locationId },
      })
      .pipe(
        timeout(5000),
        map((r) => r.screenId ?? null),
      );
  }
}
